import { KeyValuePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as plist from 'plist';
import { JsonArray, JsonValue } from '../../../models/json-value.model';

@Component({
  selector: 'ml-timeline-command-payload',
  templateUrl: './timeline.command.component.html',
  imports: [KeyValuePipe],
})
export class TimelineCommandComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly commandContentEntry = input<JsonValue>({});
  readonly commandContentKey = input('');

  isObject(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
  }

  isArray(value: unknown): value is JsonArray {
    return Array.isArray(value);
  }

  formatImage(value: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${value}`);
  }

  decode(value: string): string {
    return atob(value);
  }

  parsePlist(value: string): unknown {
    return plist.parse(value);
  }

  getType(value: JsonValue): string {
    if (this.isObject(value)) return 'object';
    if (this.isArray(value))
      if (this.isObject(value[0]) && value.length == 1) return 'object-in-array';
      else return 'array';
    const commandContentKey = this.commandContentKey();
    if (commandContentKey == 'image') return 'image';
    if (commandContentKey == 'payload') return 'profilepayload';
    return 'default';
  }

  toObject(value: JsonValue): Record<string, JsonValue> {
    return this.isObject(value) ? value : {};
  }

  toArray(value: JsonValue): JsonArray {
    return this.isArray(value) ? value : [];
  }

  firstArrayItem(value: JsonValue): JsonValue {
    const arr = this.toArray(value);
    return arr.length > 0 ? arr[0] : null;
  }

  toString(value: JsonValue): string {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string -- We intentionally want to display objects as strings for UI display purposes
    return typeof value === 'string' ? value : String(value);
  }
}
